import { useLayoutEffect, useRef, useState } from 'react';

interface SignatureCanvasProps {
    signatureDataUrl: string;
    className?: string;
}

/**
 * 서명 이미지를 canvas로 렌더링하는 컴포넌트
 * html2canvas가 data URL 이미지를 캡처하지 못하는 문제를 해결
 */
export function SignatureCanvas({ signatureDataUrl, className }: SignatureCanvasProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const [isDrawn, setIsDrawn] = useState(false);

    // useLayoutEffect로 동기적으로 실행
    useLayoutEffect(() => {
        if (!signatureDataUrl || !canvasRef.current) return;

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        // 동기적으로 이미지 로드 및 그리기
        const img = new Image();
        img.onload = () => {
            // 캔버스 크기 설정
            const width = img.naturalWidth || img.width || 200;
            const height = img.naturalHeight || img.height || 60;
            canvas.width = width;
            canvas.height = height;

            // 흰색 배경
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, width, height);

            // 이미지 그리기
            ctx.drawImage(img, 0, 0, width, height);
            setIsDrawn(true);
        };
        img.src = signatureDataUrl;
    }, [signatureDataUrl]);

    return (
        <canvas
            ref={canvasRef}
            className={className}
            data-signature-drawn={isDrawn ? 'true' : 'false'}
            data-signature-url={signatureDataUrl}
            style={{
                maxHeight: '64px',
                display: 'block',
                width: 'auto',
                height: 'auto',
                minWidth: '100px',
                minHeight: '30px',
            }}
        />
    );
}
